<p-toast [baseZIndex]="1000" position="top-right"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <div class="row">
        <div class="col-md-8">
          <lib-page-header page-title="SETORES" page-subtitle="EXERCÍCIO: {{login.exercicio.ano}}"
            image-title="assets/img/real-estate.png">
          </lib-page-header>
        </div>
        <div class="col-md-4">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/setores']" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <button (click)="submitForm()" class="btn btn-outline-info btn-sm float-right mr-4">
            Salvar
          </button>
        </div>
      </div>
      <hr class="mt-1 mb-4" />
      <div class="project-tab">
        <div class="form-row">
          <div class="col-md-12">
            <ul class="nav nav-tabs" id="myTab" role="tablist" style="font-size: 13px;">
              <li class="nav-item">
                <a class="nav-link active" id="principal-tab" data-toggle="tab" href="#principal" role="tab"
                  aria-controls="principal" aria-selected="true">Dados do Setor</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="estoque-tab" data-toggle="tab" href="#estoque" role="tab"
                  aria-controls="estoque" aria-selected="true">Estoques vinculados ao setor</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="usuarios-tab" data-toggle="tab" href="#usuarios" role="tab"
                  aria-controls="usuarios" aria-selected="true">Usuários vinculados ao setor</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="responsaveis-tab" data-toggle="tab" href="#responsaveis" role="tab"
                  aria-controls="responsaveis" aria-selected="true">Responsáveis vinculados ao setor</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="localizacoes-tab" data-toggle="tab" href="#localizacoes" role="tab"
                  aria-controls="localizacoes" aria-selected="true">Localizações vinculados ao setor</a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade show active" id="principal" role="tabpanel" aria-labelledby="principal-tab">
                <div class="form-row pt-3">
                  <div class="col-sm-12">
                    <div class="form-row">
                      <div class="form-group col-md-3">
                        <label for="sigla">Sigla<span class="text-danger">*</span></label>
                        <input #sigla id="sigla" formControlName="sigla" type="text"
                          class="form-control font-weight-bold" placeholder="Informe a sigla">
                      </div>
                      <div class="form-group offset-md-6 col-md-3">
                        <div class="checkbox checbox-switch switch-danger form-check form-check-inline float-right">
                          <label>
                            <input type="checkbox" formControlName="ativo" /><span
                              class="text-left"></span><small>Ativo</small>
                          </label>
                        </div>
                        <div class="checkbox checbox-switch switch-danger form-check form-check-inline float-right">
                          <label>
                            <input type="checkbox" formControlName="setor_protocolo" /><span
                              class="text-left"></span><small>Setor de protocolo</small>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="nome">Nome<span class="text-danger">*</span></label>
                        <input #nome id="nome" formControlName="nome" type="text" class="form-control font-weight-bold"
                          placeholder="Informe o nome">
                      </div>
                      <div class="form-group col-md-6">
                        <label for="unidade">Setor Primário:<span class="text-danger">*</span></label>
                        <p-autoComplete formControlName="unidade" [field]="unidadeAutoComplete.conversor"
                          [suggestions]="unidadeAutoComplete.lista"
                          (completeMethod)="unidadeAutoComplete.filtrar($event)"
                          inputStyleClass="form-control font-weight-bold" minLength="2" [style]="{ width: '100%' }"
                          [forceSelection]="true" [autoHighlight]="true" *ngIf="unidadeAutoComplete"
                          placeholder="Informe a unidade administrativa">
                          <ng-template let-unidade pTemplate="item">
                            {{unidade.codigo}} {{unidade.nome}}
                          </ng-template>
                        </p-autoComplete>
                      </div>
                    </div>
                  </div>
                </div>
                <br />
                <div class="form-row">
                  <div class="col-sm-12">
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="responsavel">Responsável<span class="text-danger">*</span></label>
                        <p-autoComplete formControlName="responsavel" [field]="pessoaAutoComplete.conversor"
                          [suggestions]="pessoaAutoComplete.lista" (completeMethod)="pessoaAutoComplete.filtrar($event)"
                          placeholder="Informe o responsável"
                          inputStyleClass="form-control autocomplete-radius-right font-weight-bold" minLength="2"
                          [style]="{ width: 'calc(100% - 46px)', float: 'left' }" [forceSelection]="true"
                          [autoHighlight]="true" *ngIf="pessoaAutoComplete">
                          <ng-template let-pessoa pTemplate="item">
                            {{pessoa.cpf_cnpj | CPF}} {{pessoa.nome}}
                          </ng-template>
                        </p-autoComplete>
                        <button class="btn btn-outline-secondary float-right" type="button" data-toggle="modal"
                          data-target="#dialogPessoa"
                          style="height: 36px; border-bottom-left-radius: 0px;  border-top-left-radius: 0px;">
                          <i class="fa fa-user-plus"></i>
                        </button>
                      </div>
                      <div class="form-group col-md-6">
                        <label for="cargo">Cargo<span class="text-danger">*</span></label>
                        <input id="cargo" formControlName="cargo" type="text" class="form-control font-weight-bold"
                          placeholder="Informe o cargo">
                      </div>
                    </div>
                  </div>
                </div>

                <br />
                <div class="form-row">
                  <div class="col-sm-12">
                    <div class="form-row">
                      <div class="form-group col-md-3">
                        <label for="cep">CEP<span class="text-danger">*</span></label>
                        <p-inputMask id="cep" formControlName="cep" mask="99999-999" slotChar=" " unmask="true"
                          styleClass="form-control font-weight-bold" (onBlur)="buscarCEP()" placeholder="Informe o CEP">
                        </p-inputMask>
                      </div>
                      <div class="form-group col-md-3">
                        <label for="telefone">Telefone<span class="text-danger">*</span></label>
                        <input formControlName="telefone"
                          [imask]="{mask: [  {mask: '(00) 0000-0000'}, {mask: '(00) 00000-0000'} ]}" unmask="true"
                          type="text" name="telefone" class="form-control font-weight-bold"
                          placeholder="Informe o telefone" />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="email">E-mail<span class="text-danger">*</span></label>
                        <input id="email" formControlName="email" type="text" class="form-control font-weight-bold"
                          placeholder="Informe o e-mail">
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="endereco">Endereço<span class="text-danger">*</span></label>
                        <input id="endereco" formControlName="endereco" type="text"
                          class="form-control font-weight-bold" placeholder="Informe o endereço">
                      </div>
                      <div class="form-group col-md-6">
                        <label for="bairro">Bairro<span class="text-danger">*</span></label>
                        <input id="bairro" formControlName="bairro" type="text" class="form-control font-weight-bold"
                          placeholder="Informe o bairro">
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-12">
                        <label for="complemento">Complemento</label>
                        <input id="complemento" formControlName="complemento" type="text" class="form-control"
                          placeholder="Informe o complemento">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="estoque" role="tabpanel" aria-labelledby="estoque-tab">
                <app-setor-almoxarifado [(lista)]="estoques" [login]="login">
                </app-setor-almoxarifado>
              </div>
              <div class="tab-pane fade mt-3" id="usuarios" role="tabpanel" aria-labelledby="usuarios-tab">
                <lib-usuario-list-simples [parametros]="{'setor.id' : entidade.id}">
                </lib-usuario-list-simples>
              </div>
              <div class="tab-pane fade mt-3" id="responsaveis" role="tabpanel" aria-labelledby="responsaveis-tab">
                <app-setor-responsavel [(setor)]="entidade" [(lista)]="responsaveis"
                  (callback)="atualizarResponsavel($event)" [login]="login">
                </app-setor-responsavel>
              </div>
              <div class="tab-pane fade mt-3" id="localizacoes" role="tabpanel" aria-labelledby="localizacoes-tab">
                <app-setor-localizacao [(setor)]="entidade" [(lista)]="localizacoes" [login]="login">
                </app-setor-localizacao>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr class="mt-2 mb-4" />
      <div class="row">
        <div class="col-12">
          <button (click)="submitForm(true)" class="btn btn-sm btn-outline-info">
            <img src="assets/img/global/tick.png" alt="salvar" height="20" width="20">
            Salvar & novo
          </button>
        </div>
      </div>
    </form>
    <!-- <pre *ngIf="entidadeForm">{{ entidadeForm.value | json}}</pre> -->
  </div>
</div>
<lib-pessoa-cadastro-dlg [login]="login" (callback)="carregarResponsavel($event)"></lib-pessoa-cadastro-dlg>